/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import { useParams } from 'umi';
import { getFilterConfig } from '../utils';

export interface IOverallKPIServiceProps
  extends BaseServiceComponentProps {
  metric: string;
  gameCodes: string[];
  [key: string]: any;
}

export default function OverallKPIService(
  props: IOverallKPIServiceProps,
) {
  const {
    style,
    className,
    dataKey = 'CommonData',
    api,
    children,
    filter,
    metrics,
    gameCodes,
    extraParams = {},
    formatData: propsFormatData,
    data,
    tabFilter,
    filterConfig,
    paymentType,
    ...restProps
  } = props || {};
  
  const { filterChangeParam, ...restExtraParams } = extraParams;
  const filterVal = useMemo(() => ({ ...tabFilter, ...filter }), [tabFilter, filter]);

  const { studioId } = useParams() || {} as any;
  const formatData = (data: any) => {
    if (propsFormatData && typeof propsFormatData === 'function') return propsFormatData?.(data);
    const { metrics_list: metricsData } = data || [];
    return metricsData || [];
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={{ ...props.data, studioId }}
        dataKey={dataKey}
        filterLoading={!tabFilter?.date}
        formatData={formatData}
        filterVal={filterVal}
        trackData={['studioId']}
        beforeRequest={(data) => {
          const { filterVal } = data;
          const { date, date_type: dateType, selectorList, payType} = filterVal || {};
          const params = {
            studio_code: studioId,
            game_codes: gameCodes,
            period: dateType || "daily",
            start_time: date,
            end_time: date,
            metrics,
            filters: {
              zone_list: ['255'],
              market_list: ['255'],
              channel_list: ['255'],
              os_list: ['255'],
              category_list: ['255'],
              product_list: ['255'],
              ...filterChangeParam,
            },
            ...restExtraParams
          };
          // 筛选器过滤
          if(filterConfig){
            const processedFilters = getFilterConfig(selectorList, filterConfig, filterChangeParam);
            params.filters = processedFilters;
          }  
          if (payType) {
            // 增加筛选器参数
            params.filters.custom_filters = [
              {
                key: 'payment_type',
                filter_list: [paymentType || payType],
              },
            ];
          }
          return params;
        }}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(restProps || {}),
            ...data,
            filter,
            tabFilter
          }),
        )}
      </Service>
    </div>
  );
}
